import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from '@modules/main/main.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {LoginComponent} from '@modules/login/login.component';
import {ProfileComponent} from '@pages/profile/profile.component';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {AuthGuard} from '@guards/auth.guard';
import {NonAuthGuard} from '@guards/non-auth.guard';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {SubMenuComponent} from '@pages/main-menu/sub-menu/sub-menu.component';
import { NewJoiningFormsComponent } from '@components/new-joining-modules/new-joining-forms/new-joining-forms.component';
import { NewJoiningFormReportComponent } from '@components/new-joining-modules/new-joining-form-report/new-joining-form-report.component';
import { NewJoiningAttendanceReportComponent } from '@components/new-joining-modules/new-joining-attendance/new-joining-attendance-report.component';
import { NewJoiningPayrollTableComponent } from '@components/new-joining-modules/new-joining-payroll/new-joining-payroll-table.component';
import { WorksheetEntryFormComponent } from '@modules/employee-modules/worksheet-entry-form/worksheet-entry-form.component';
import { WorksheetEntryTableComponent } from '@components/new-joining-modules/worksheet-entry-table/worksheet-entry-table.component';
import { DevelopmentWorksheetEntryFormComponent } from '@modules/employee-modules/development-worksheet-entry-form/development-worksheet-entry-form.component';
import { DevelopmentWorksheetEntryTableComponent } from '@components/new-joining-modules/development-worksheet-entry-table/development-worksheet-entry-table.component';
import { DataEntryTableComponent } from '@modules/employee-modules/data-entry-table/data-entry-table.component';

const routes: Routes = [
    {
        path: 'main',
        component: MainComponent,
        // canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        children: [
            {
                path: 'profile',
                component: ProfileComponent
            },
            {
                path: 'blank',
                component: BlankComponent
            },
            {
                path: 'sub-menu-1',
                component: SubMenuComponent
            },
            {
                path: 'sub-menu-2',
                component: BlankComponent
            },
            {
                path: '',
                component: DashboardComponent
            },
            {
                path: 'new-joining-form',
                component: NewJoiningFormsComponent
            },
            {
                path: 'new-joining-report',
                component: NewJoiningFormReportComponent
            },
            {
                path: 'new-joining-attendance-report',
                component: NewJoiningAttendanceReportComponent
            },
            {
                path: 'new-joining-payroll',
                component: NewJoiningPayrollTableComponent
            },
            {
                path: 'employee-worksheet-entry',
                component: WorksheetEntryFormComponent
            },
            {
                path: 'worksheet-entry-table',
                component: WorksheetEntryTableComponent
            },
            {
                path: 'development-worksheet-entry',
                component: DevelopmentWorksheetEntryFormComponent
            },
            {
                path: 'development-worksheet-entry-table',
                component: DevelopmentWorksheetEntryTableComponent
            },
            {
                path: 'data-entry-table',
                component: DataEntryTableComponent
            },
            
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'recover-password',
        component: RecoverPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {path: '**', redirectTo: 'login'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash : true})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
